import { useEffect } from 'react';

import { useLogException } from '../error-boundary/utils';

const REFERRER_PARAM = 'referrer';

/**
 * Returns the value of the `?referrer=` parameter from the current URL, or `undefined` if absent.
 */
export const getReferrerFromUrl = (): string | undefined =>
	new URLSearchParams(window.location.search).get(REFERRER_PARAM) ?? undefined;

/**
 * Removes the `?referrer=` parameter from the browser URL using `window.history.replaceState`.
 * This is a no-op if `referrer` is not present in the current URL.
 */
export const removeReferrerFromUrl = (logException: (error: unknown) => void): void => {
	try {
		const url = new URL(window.location.href);

		if (!url.searchParams.has(REFERRER_PARAM)) {
			return;
		}

		url.searchParams.delete(REFERRER_PARAM);

		window.history.replaceState(null, '', url.href);
	} catch (error) {
		logException(error);
	}
};

/**
 * This component clears the referrer from the query parameters after the first render
 */
export const RemoveReferrer = () => {
	const logException = useLogException();

	useEffect(() => {
		removeReferrerFromUrl(logException);
	}, [logException]);

	return null;
};
